import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconClock = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round'>
      <circle cx='12' cy='12' r='10' />
      <path d='M12 6v6l4 2' />
    </g>
  </SDIcon>
)

export default IconClock
